export * from './app-header.component';



// WEBPACK FOOTER //
// /app/src/app/components/app-header/index.ts